import ImageCompare from "./image_comparison_viewer";

export default function imageComparison() {
  const comparisonContainer = document.getElementById("image_compare");
  if (comparisonContainer) {
    const options = {
      showLabels: true,
      labelOptions: {
        before: 'LiDAR',
        after: 'Traditional'
      }
    }
    new ImageCompare(comparisonContainer, options).mount();
  }
}